import React from 'react';
import { Reload } from '@insurancemenu/imenu-components-lib/dist/icons';
import { DiscountFormController } from 'store/modules/override-rates/ratesOverriderDelegate';
import { observer } from 'mobx-react-lite';
import { ApplyDiscountForm } from '../ApplyDiscountForm';
import { DiscountPanelStyled, RestoreQuotesButtonStyled } from './styles';
import { OVERRIDE_RATES_DISCOUNT_PANEL_TEST_ID, OVERRIDE_RATES_RESTORE_RATES_BUTTON_TEST_ID } from '../constants';

interface Props {
  originalRatesName: string;
  restoreRates: () => void;
  formController: DiscountFormController;
}

export const DiscountPanel: React.FC<Props> = observer(({ originalRatesName, restoreRates, formController }) => {
  return (
    <DiscountPanelStyled data-test-id={OVERRIDE_RATES_DISCOUNT_PANEL_TEST_ID}>
      <ApplyDiscountForm formController={formController} />
      <RestoreQuotesButtonStyled
        type="text"
        leftIconProp={<Reload />}
        onClick={restoreRates}
        data-test-id={OVERRIDE_RATES_RESTORE_RATES_BUTTON_TEST_ID}
      >
        Restore {originalRatesName} Rates
      </RestoreQuotesButtonStyled>
    </DiscountPanelStyled>
  );
});
